import { Message, MessageBox } from 'element-ui';
export function exoprtFile(res, name) {
  const blob = new Blob([res.data], { type: '.xlsx' });
  const URL = window.URL || window.webkitURL;
  const link = document.createElement('a');
  const href = URL.createObjectURL(blob);
  link.setAttribute('href', href);
  let contentDisposition = decodeURI(res.headers['content-disposition']);
  console.log(res);

  if (!!name) {
    link.setAttribute('download', name);
  } else {
    const fileName = contentDisposition.split("filename*=utf-8''")[1];
    link.setAttribute('download', fileName);
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(href);
}
export function copy(value) {
  if (!value) return;
  // 创建input标签
  const input = document.createElement('input');
  // 将input的值设置为需要复制的内容
  input.value = value;
  // 添加input标签
  document.body.appendChild(input);
  // 选中input标签
  input.select();
  // 执行复制
  document.execCommand('copy');
  // 成功提示信息
  Message.success('复制成功!');
  // 移除input标签
  document.body.removeChild(input);
}
//获得两个小数相加的精确值
export function accountAdd(num1, num2) {
  //要相加的两个数
  var baseNum, baseNum1, baseNum2;
  try {
    baseNum1 = num1.toString().split('.')[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  var n = (num1 * baseNum + num2 * baseNum) / baseNum;
  return n;
}



// WEBPACK FOOTER //
// ./src/utils/util.js